import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../../OptionsColor";
import { RollLight } from "./RollLight";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Roll = /*#__PURE__*/function () {
  function Roll() {
    _classCallCheck(this, Roll);
    this.darken = new RollLight();
    this.enable = false;
    this.enlighten = new RollLight();
    this.mode = "vertical";
    this.speed = 25;
  }
  _createClass(Roll, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.backColor !== undefined) {
        this.backColor = OptionsColor.create(this.backColor, data.backColor);
      }
      this.darken.load(data.darken);
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      this.enlighten.load(data.enlighten);
      if (data.mode !== undefined) {
        this.mode = data.mode;
      }
      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }
    }
  }]);
  return Roll;
}();